import { render, staticRenderFns } from "./friendWrap.vue?vue&type=template&id=3c8b68d6&"
import script from "./friendWrap.vue?vue&type=script&lang=js&"
export * from "./friendWrap.vue?vue&type=script&lang=js&"
import style0 from "./friendWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports